import PowerConsumptionUpdate from "../components/PowerConsumption/PowerConsumptionUpdate";

const UpdatePowerConsumptionPage = () =>{ 
     
    return(
         
         <PowerConsumptionUpdate/>
    )
}

export default UpdatePowerConsumptionPage;